/** Nullable social / web URL columns stored on branches, batches, and associations. */
export type EntitySocialLinksFields = {
  social_facebook_url: string | null;
  social_instagram_url: string | null;
  social_youtube_url: string | null;
  social_website_url: string | null;
  social_other_url: string | null;
};

/** Trim; return null if empty. */
export function socialUrlOrNull(raw: string): string | null {
  const t = raw.trim();
  return t ? t : null;
}

/**
 * Safe href for user-entered URLs: allow http(s), mailto, tel; bare hosts get https://.
 * Rejects javascript:, data:, vbscript:, file:, and other non-web schemes.
 */
export function normalizeExternalHref(raw: string | null | undefined): string | null {
  const t = raw?.trim() ?? "";
  if (!t) return null;
  const lower = t.toLowerCase();
  if (
    lower.startsWith("javascript:") ||
    lower.startsWith("data:") ||
    lower.startsWith("vbscript:") ||
    lower.startsWith("file:")
  ) {
    return null;
  }
  if (/^[a-z][a-z0-9+.-]*:/i.test(t)) {
    if (/^https?:\/\//i.test(t)) return t;
    if (/^mailto:/i.test(t) || /^tel:/i.test(t)) return t;
    return null;
  }
  return `https://${t}`;
}
